import { InputTypes, ValidatorTypes } from '@cashier/cashier-model';

import { FieldCollector } from '../model';

export const InformationFieldCollector: FieldCollector = {
  collect: (formSchema, field) => {
    formSchema.informationFieldMap = formSchema.informationFieldMap || {};

    if (!formSchema.informationFieldMap[field.name]) {
      formSchema.informationFieldMap[field.name] = {
        ...field,
        validatorType: ValidatorTypes.COMMON,
      };
    }
  },
  shouldCollect: (field) => {
    return field.type === InputTypes.CopyableText;
  },
};
